// ui-logic.js
export const isPageEmbedded = () => {
  console.log(window !== window.top);
  return window !== window.top;
}
export let actions = {
  startTour: false,
  chat_1_1: false,
  videoCall: false,
  takeSeat: false,
  screenShare: false,
  worldChat: false,
  answerOneOnOneCall: false,
  answerOneOnOneChat: false,
}

export const startEmbed = () => {
  $(".guest-welcome-modal-holder").hide();
  $("#save-welcome-guest").trigger("click");
}